import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import i18n from "i18next";

const availableLanguages = { en: "English", fr: "Français", it: "Italiano" };

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.VITE_ENV === "development",
    ns: [
      "account",
      "common",
      "company",
      "errors",
      "navigation",
      "notifications",
      "reseller",
      "settings",
      "vault",
      "financing",
      "treasury",
      "onboarding",
    ],
    defaultNS: "common",
    supportedLngs: ["fr", "en", "it"],
    fallbackLng: "fr",
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    backend: {
      loadPath: import.meta.env.DEV
        ? "/locales/{{lng}}/{{ns}}.json"
        : import.meta.env.VITE_API_URL + "/react-i18n/{{lng}}/{{ns}}",
    },
  });

export { i18n, availableLanguages };
